import React from 'react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const FAQKey = {
  PVP_MEANING: 'pvp-meaning',
  PVP_INVOICING: 'pvp-invoicing'
};
export const paidViaPartnerMeaningFAQ = {
  question: "What does 'paid-via-vendor' mean?",
  key: FAQKey.PVP_MEANING,
  answer: /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: "Paid-via-vendor apps are licensed and purchased directly through the vendor who makes this app."
    }), /*#__PURE__*/_jsx("p", {
      children: "Payment for paid-via-vendor apps is not handled by Atlassian."
    })]
  })
};
export const paidViaPartnerInvoiceBundlingFAQ = {
  question: 'Will paid-via-vendor transactions be on my Atlassian invoice?',
  key: FAQKey.PVP_INVOICING,
  answer: /*#__PURE__*/_jsxs("p", {
    children: ["Paid-via-vendor transactions are not managed by Atlassian. This means transactions for paid-via-vendor apps will ", /*#__PURE__*/_jsx("strong", {
      children: "not"
    }), " be on your Atlassian invoice."]
  })
};
export default function getPaidViaPartnerFAQs() {
  return [paidViaPartnerMeaningFAQ, paidViaPartnerInvoiceBundlingFAQ];
}